import {KeyHistoryRecord} from "../../api/Model";
import {Box, Stack, Tooltip, Typography} from "@mui/material";
import React from "react";
import {dateTimeString} from "../../util/DateUtil";
import {Principal} from "../principal/Principal";

export function KeyHistoryRecordAudit({record}: {
    record: KeyHistoryRecord,
}) {
    const by = record.createdBy || record.updatedBy;
    if (!by) return null;

    return (
        <Tooltip
            arrow
            placement="right"
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: 500,
                    },
                },
            }}
            title={
                <Stack direction="column" gap={2}>
                    {(record.createdBy || record.createdAt) && (
                        <Typography variant="body2">
                            Recorded {record.createdBy && (
                            <><br/>&nbsp;by <b>{record.createdBy}</b></>
                        )} {record.createdAt && (
                            <><br/>&nbsp;{dateTimeString(new Date(record.createdAt))}</>
                        )}
                        </Typography>
                    )}
                    {((record.updatedBy || record.updatedAt) && (record.updatedBy !== record.createdBy || record.updatedAt !== record.createdAt)) && (
                        <Typography variant="body2">
                            Updated {record.updatedBy && (
                            <><br/>&nbsp;by <b>{record.updatedBy}</b></>
                        )} {record.updatedAt && (
                            <><br/>&nbsp;{dateTimeString(new Date(record.updatedAt))}</>
                        )}
                        </Typography>
                    )}
                </Stack>
            }
        >
            <Box sx={{cursor: 'default', display: 'flow'}}>
                <Stack direction="row" gap={1} alignItems="center">
                    {by && (
                        <Principal principalEmail={by}/>
                    )}
                    {(record.updatedBy && record.createdBy && record.updatedBy !== record.createdBy) && (
                        '+1'
                    )}
                </Stack>
            </Box>
        </Tooltip>
    );
}